
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SortSettingsGrid extends SiteEntityGrid<SortSettingsRow, any> {
        protected getColumnsKey() { return 'Rebalancer.SortSettings'; }
        protected getDialogType() { return SortSettingsDialog; }
        protected getIdProperty() { return SortSettingsRow.idProperty; }
        protected getLocalTextPrefix() { return SortSettingsRow.localTextPrefix; }
        protected getService() { return SortSettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}